import { IChartFormat, IDateCompareKey, IYAxisFormat } from './chart-settings.interface';

const DATES_COMPARE: Record<IDateCompareKey, string> = {
  'Last Year vs This Year': $localize`:@@chart.last_this_year_compare:Last Year vs This Year`,
  'Last Month vs This Month': $localize`:@@chart.last_this_month_compare:Last Month vs This Month`,
  'Last Week vs This Week': $localize`:@@chart.last_this_week_compare:Last Week vs This Week`,
  'Yesterday vs Today': $localize`:@@chart.yesterday_today_compare:Yesterday vs Today`,
};

const CHART_FORMAT: Record<IChartFormat, string> = {
  Column: $localize`:@@chart.column:Column`,
  Line: $localize`:@@chart.line:Line`,
  Area: $localize`:@@chart.area:Area`,
};
const Y_AXIS_FORMAT: Record<IYAxisFormat, string> = {
  Number: $localize`:@@common.number:Number`,
  Percent: $localize`:@@chart.percent:Percent`,
  Money: $localize`:@@common.money:Money`,
};

export { DATES_COMPARE, CHART_FORMAT, Y_AXIS_FORMAT };
